import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TooltipDirective } from '@shared/directives/tooltip.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective],
  styles: [],
  template: `
    <div [auxTooltip]="params.tooltip || ''" [innerHTML]="params.template"></div>
  `,
})
export class AgHtmlHeaderComponent implements IHeaderAngularComp {
  params!: IHeaderParams & { tooltip?: string };

  agInit(params: IHeaderParams & { tooltip?: string }): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }
}
